// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/*
* VARIABLES
*/
/*
* MIXINS
*/
.Poster {
  position: relative;
  overflow: hidden;
  display: inline-block;
  white-space: normal;
  vertical-align: top;
  padding: 0 3px;
  margin-bottom: 4vw;
  width: 100%;
  transform: scale(1);
  transition: transform 0.3s ease-out, opacity 0.3s ease-out;
  cursor: pointer;
}
@media (min-width: 330px) {
  .Poster {
    width: 50%;
  }
  .Poster:nth-child(1n) {
    transform-origin: initial;
  }
  .Poster:nth-child(2n+1) {
    transform-origin: left;
  }
  .Poster:nth-child(2n+2) {
    transform-origin: right;
  }
}
@media (min-width: 625px) {
  .Poster {
    width: 33.3%;
  }
  .Poster:nth-child(1n) {
    transform-origin: initial;
  }
  .Poster:nth-child(3n+1) {
    transform-origin: left;
  }
  .Poster:nth-child(3n+3) {
    transform-origin: right;
  }
}
@media (min-width: 998px) {
  .Poster {
    width: 25%;
  }
  .Poster:nth-child(1n) {
    transform-origin: initial;
  }
  .Poster:nth-child(4n+1) {
    transform-origin: left;
  }
  .Poster:nth-child(4n+4) {
    transform-origin: right;
  }
}
@media (min-width: 1378px) {
  .Poster {
    width: 16.6%;
  }
  .Poster:nth-child(1n) {
    transform-origin: initial;
  }
  .Poster:nth-child(6n+1) {
    transform-origin: left;
  }
  .Poster:nth-child(6n+6) {
    transform-origin: right;
  }
}
.Poster img {
  display: block;
  height: 100%;
  width: 100%;
  border-radius: 5px;
}
.Poster__fallback {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  min-width: 100%;
  min-height: 110px;
  border-radius: 5px;
  text-align: center;
  font-weight: 500;
  z-index: -1;
  padding: 0 1em;
}
.Poster__info {
  position: absolute;
  left: 3px;
  bottom: 0;
  transform: translateY(15%);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-end;
  width: calc(100% - 6px);
  height: 100%;
  padding: 0.6em;
  opacity: 0;
  z-index: 2;
  border-radius: 5px;
  pointer-events: none;
  transition: all 0.4s ease 0.15s;
}
@media (min-width: 768px) {
  .Poster__info {
    pointer-events: all;
  }
}
.Poster__info--iconswrp {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.Poster__info--icon {
  display: inline-flex;
  padding: 6px;
  border-radius: 50%;
  font-size: 12px;
  cursor: pointer;
  margin: 0 5px;
  margin-bottom: 0.6em;
  background: transparent;
  color: #f2f2f2;
  border: 1px solid #f2f2f2;
  transition: all 0.3s ease-out;
  outline: none;
}
@media (min-width: 1024px) {
  .Poster__info--icon {
    font-size: 14px;
    padding: 8px;
    margin-bottom: 0.8em;
  }
}
@media (min-width: 1378px) and (max-width: 1680px) {
  .Poster__info--icon {
    font-size: 12px;
    padding: 6px;
    margin-bottom: 0.6em;
  }
}
@media (min-width: 1680px) {
  .Poster__info--icon {
    font-size: 14px;
    padding: 8px;
    margin-bottom: 0.8em;
  }
}
.Poster__info--icon:hover {
  background: #f2f2f2;
  color: #141414;
}
.Poster__info--icon:first-child {
  margin-left: 0;
  background: #f2f2f2;
  color: #141414;
}
.Poster__info--icon:first-child:hover {
  background: rgba(242, 242, 242, 0.7);
  border-color: rgba(242, 242, 242, 0.7);
}
.Poster__info--title h3 {
  font-size: 12px;
  font-weight: 600;
  text-transform: none;
}
@media (min-width: 1024px) {
  .Poster__info--title h3 {
    font-size: 15px;
  }
}
@media (min-width: 1378px) and (max-width: 1680px) {
  .Poster__info--title h3 {
    font-size: 12px;
  }
}
@media (min-width: 1680px) {
  .Poster__info--title h3 {
    font-size: 15px;
  }
}
.Poster__info--title p {
  font-size: 10px;
  margin-top: 0.3vw;
  margin-bottom: 0;
}
@media (min-width: 1024px) {
  .Poster__info--title p {
    font-size: 13px;
  }
}
@media (min-width: 1378px) and (max-width: 1680px) {
  .Poster__info--title p {
    font-size: 10px;
  }
}
@media (min-width: 1680px) {
  .Poster__info--title p {
    font-size: 13px;
  }
}
.Poster__info--genres {
  display: block;
  width: 100%;
}
.Poster__info--genres .genre-title {
  display: inline-block;
  width: auto;
  font-size: 8px;
  margin: 0 0.3vw 0 0;
}
@media (min-width: 1024px) {
  .Poster__info--genres .genre-title {
    font-size: 10px;
  }
}
@media (min-width: 1378px) and (max-width: 1680px) {
  .Poster__info--genres .genre-title {
    font-size: 8px;
  }
}
@media (min-width: 1680px) {
  .Poster__info--genres .genre-title {
    font-size: 10px;
  }
}
.Poster__info--genres .genre-title:after {
  content: "●";
  display: inline-block;
  margin: 0 0 0 0.3vw;
  font-size: 6px;
  text-shadow: 0 1px 1px rgba(0, 0, 0, 0);
  color: rgba(242, 242, 242, 0.4);
}
.Poster__info--genres .genre-title:last-child:after {
  display: none;
}
.Poster::after {
  content: "";
  position: absolute;
  top: 0;
  left: 3px;
  width: calc(100% - 6px);
  height: 100%;
  border-radius: 5px;
  background: linear-gradient(360deg, rgba(0, 0, 0, 0.6) 0%, transparent 65%);
  z-index: 0;
  opacity: 0;
  transition: opacity 0.2s ease-out;
}
@media (min-width: 768px) {
  .Poster:hover {
    transform: scale(1.3) !important;
    transition-delay: 0.3s;
    z-index: 1;
    opacity: 1;
  }
  .Poster:hover::after {
    opacity: 1;
  }
  .Poster:hover .Poster__info {
    opacity: 1;
    transform: translateY(0);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Poster/poster.scss","webpack://./src/scss/_mixin.scss","webpack://./src/scss/_variables.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB;;CAAA;AAKA;;CAAA;ADFA;EACI,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,0DAAA;EACA,eAAA;AAKJ;ACyDQ;EDzER;IAcQ,UAAA;EAMN;EAJM;IACI,yBAAA;EAMV;EAJM;IACI,sBAAA;EAMV;EAJM;IACI,uBAAA;EAMV;AACF;AC2CQ;EDzER;IA2BQ,YAAA;EAON;EALM;IACI,yBAAA;EAOV;EALM;IACI,sBAAA;EAOV;EALM;IACI,uBAAA;EAOV;AACF;AC6BQ;EDzER;IAwCQ,UAAA;EAQN;EANM;IACI,yBAAA;EAQV;EANM;IACI,sBAAA;EAQV;EANM;IACI,uBAAA;EAQV;AACF;ACeQ;EDzER;IAqDQ,YAAA;EASN;EAPM;IACI,yBAAA;EASV;EAPM;IACI,sBAAA;EASV;EAPM;IACI,uBAAA;EASV;AACF;AANI;EACI,cAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;AAQR;AALI;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,cAAA;AAOR;AAJI;EACI,kBAAA;EACA,SAAA;EACA,SAAA;EACA,0BAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,yBAAA;EACA,uBAAA;EACA,YAAA;EACA,cAAA;EACA,UAAA;EACA,UAAA;EACA,kBAAA;EACA,oBAAA;EACA,+BAAA;AAMR;ACxCQ;EDkBJ;IAmBQ,mBAAA;EAOV;AACF;AALQ;EACI,aAAA;EACA,mBAAA;EACA,2BAAA;AAOZ;AAJQ;EACI,oBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,aAAA;EACA,oBAAA;EACA,uBAAA;EACA,cEnIJ;EFoII,yBAAA;EACA,6BAAA;EACA,aAAA;AAMZ;AChEQ;ED8CA;IAeQ,eAAA;IACA,YAAA;IACA,oBAAA;EAOd;AACF;ACvEQ;ED8CA;IAqBQ,eAAA;IACA,YAAA;IACA,oBAAA;EAQd;AACF;AC9EQ;ED8CA;IA2BQ,eAAA;IACA,YAAA;IACA,oBAAA;EASd;AACF;AAPY;EACI,mBE3JR;EF4JQ,cEzJR;AFkKR;AANY;EACI,cAAA;EACA,mBEjKR;EFkKQ,cE/JR;AFuKR;AANgB;EACI,oCAAA;EACA,sCAAA;AAQpB;AAFY;EACI,eAAA;EACA,gBAAA;EACA,oBAAA;AAIhB;ACvGQ;EDgGI;IAMQ,eAAA;EAKlB;AACF;AC5GQ;EDgGI;IAUQ,eAAA;EAMlB;AACF;ACjHQ;EDgGI;IAcQ,eAAA;EAOlB;AACF;AAJY;EACI,eAAA;EACA,iBAAA;EACA,gBAAA;AAMhB;AC3HQ;EDkHI;IAMQ,eAAA;EAOlB;AACF;AChIQ;EDkHI;IAUQ,eAAA;EAQlB;AACF;ACrIQ;EDkHI;IAcQ,eAAA;EASlB;AACF;AALQ;EACI,cAAA;EACA,WAAA;AAOZ;AALY;EACI,qBAAA;EACA,WAAA;EACA,cAAA;EACA,mBAAA;AAOhB;ACpJQ;EDyII;IAOQ,eAAA;EAQlB;AACF;ACzJQ;EDyII;IAWQ,cAAA;EASlB;AACF;AC9JQ;EDyII;IAeQ,eAAA;EAUlB;AACF;AARgB;EACI,YAAA;EACA,qBAAA;EACA,mBAAA;EACA,cAAA;EACA,uCAAA;EACA,+BAAA;AAUpB;AAPgB;EACI,aAAA;AASpB;AAHI;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,2EAAA;EACA,UAAA;EACA,UAAA;EACA,iCAAA;AAKR;AC3LQ;ED0LA;IACI,gCAAA;IACA,sBAAA;IACA,UAAA;IACA,UAAA;EAIV;EAFU;IACI,UAAA;EAId;EADU;IACI,UAAA;IACA,wBAAA;EAGd;AACF","sourcesContent":["@import '../../scss/mixin';\n@import \"../../scss/variables\";\n\n.Poster {\n    position: relative;\n    overflow: hidden;\n    display: inline-block;\n    white-space: normal;\n    vertical-align: top;\n    padding: 0 3px;\n    margin-bottom: 4vw;\n    width: 100%;\n    transform: scale(1);\n    transition: transform 0.3s ease-out, opacity 0.3s ease-out;\n    cursor: pointer;\n\n    @include mq(330px) {\n        width: 50%;\n\n        &:nth-child(1n) {\n            transform-origin: initial;\n        }\n        &:nth-child(2n+1) {\n            transform-origin: left;\n        }\n        &:nth-child(2n+2) {\n            transform-origin: right;\n        }\n    }\n    @include mq(625px) {\n        width: 33.3%;\n\n        &:nth-child(1n) {\n            transform-origin: initial;\n        }\n        &:nth-child(3n+1) {\n            transform-origin: left;\n        }\n        &:nth-child(3n+3) {\n            transform-origin: right;\n        }\n    }\n    @include mq(998px) {\n        width: 25%;\n\n        &:nth-child(1n) {\n            transform-origin: initial;\n        }\n        &:nth-child(4n+1) {\n            transform-origin: left;\n        }\n        &:nth-child(4n+4) {\n            transform-origin: right;\n        }\n    }\n    @include mq(1378px) {\n        width: 16.6%;\n\n        &:nth-child(1n) {\n            transform-origin: initial;\n        }\n        &:nth-child(6n+1) {\n            transform-origin: left;\n        }\n        &:nth-child(6n+6) {\n            transform-origin: right;\n        }\n    }\n\n    img {\n        display: block;\n        height: 100%;\n        width: 100%;\n        border-radius: 5px;\n    }\n\n    &__fallback {\n        position: absolute;\n        top: 0;\n        left: 0;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        height: 100%;\n        width: 100%;\n        min-width: 100%;\n        min-height: 110px;\n        border-radius: 5px;\n        text-align: center;\n        font-weight: 500;\n        z-index: -1;\n        padding: 0 1em;\n    }\n\n    &__info {\n        position: absolute;\n        left: 3px;\n        bottom: 0;\n        transform: translateY(15%);\n        display: flex;\n        flex-direction: column;\n        align-items: flex-start;\n        justify-content: flex-end;\n        width: calc(100% - 6px);\n        height: 100%;\n        padding: 0.6em;\n        opacity: 0;\n        z-index: 2;\n        border-radius: 5px;\n        pointer-events: none;\n        transition: all .4s ease .15s;\n\n        @include mq('md') {\n            pointer-events: all;\n        }\n\n        &--iconswrp {\n            display: flex;\n            align-items: center;\n            justify-content: flex-start;\n        }\n\n        &--icon {\n            display: inline-flex;\n            padding: 6px;\n            border-radius: 50%;\n            font-size: 12px;\n            cursor: pointer;\n            margin: 0 5px;\n            margin-bottom: 0.6em;\n            background: transparent;\n            color: $white;\n            border: 1px solid $white;\n            transition: all 0.3s ease-out;\n            outline: none;\n\n            @include mq('lg') {\n                font-size: 14px;\n                padding: 8px;\n                margin-bottom: 0.8em;\n            }\n\n            @include mq(1378px, 1680px) {\n                font-size: 12px;\n                padding: 6px;\n                margin-bottom: 0.6em;\n            }\n\n            @include mq(1680px) {\n                font-size: 14px;\n                padding: 8px;\n                margin-bottom: 0.8em;\n            }\n\n            &:hover {\n                background: $white;\n                color: $black;\n            }\n\n            &:first-child {\n                margin-left: 0;\n                background: $white;\n                color: $black;\n\n                &:hover {\n                    background: rgba($white, 0.7);\n                    border-color: rgba($white, 0.7);\n                }\n            }\n        }\n\n        &--title {\n            h3 {\n                font-size: 12px;\n                font-weight: 600;\n                text-transform: none;\n\n                @include mq('lg') {\n                    font-size: 15px;\n                }\n\n                @include mq(1378px, 1680px) {\n                    font-size: 12px;\n                }\n\n                @include mq(1680px) {\n                    font-size: 15px;\n                }\n            }\n\n            p {\n                font-size: 10px;\n                margin-top: 0.3vw;\n                margin-bottom: 0;\n\n                @include mq('lg') {\n                    font-size: 13px;\n                }\n\n                @include mq(1378px, 1680px) {\n                    font-size: 10px;\n                }\n\n                @include mq(1680px) {\n                    font-size: 13px;\n                }\n            }\n        }\n\n        &--genres {\n            display: block;\n            width: 100%;\n\n            .genre-title {\n                display: inline-block;\n                width: auto;\n                font-size: 8px;\n                margin: 0 0.3vw 0 0;\n\n                @include mq('lg') {\n                    font-size: 10px;\n                }\n\n                @include mq(1378px, 1680px) {\n                    font-size: 8px;\n                }\n\n                @include mq(1680px) {\n                    font-size: 10px;\n                }\n\n                &:after {\n                    content: \"●\";\n                    display: inline-block;\n                    margin: 0 0 0 0.3vw;\n                    font-size: 6px;\n                    text-shadow: 0 1px 1px rgba(0, 0, 0, 0);\n                    color: rgba($white, 0.4);\n                }\n\n                &:last-child:after {\n                    display: none;\n                }\n            }\n        }\n    }\n\n    &::after {\n        content: \"\";\n        position: absolute;\n        top: 0;\n        left: 3px;\n        width: calc(100% - 6px);\n        height: 100%;\n        border-radius: 5px;\n        background: linear-gradient(360deg, rgba(0, 0, 0, 0.6) 0%, transparent 65%);\n        z-index: 0;\n        opacity: 0;\n        transition: opacity 0.2s ease-out;\n    }\n\n    @include mq('md') {\n        &:hover {\n            transform: scale(1.3) !important;\n            transition-delay: 0.3s;\n            z-index: 1;\n            opacity: 1;\n\n            &::after {\n                opacity: 1;\n            }\n\n            .Poster__info {\n                opacity: 1;\n                transform: translateY(0);\n            }\n        }\n    }\n}","/*\n* VARIABLES\n*/\n$breakpoints: (ll: 1450px, lg: 1024px, md: 768px, sm: 640px, xs: 400px) !default;\n\n/*\n* MIXINS\n*/\n@mixin mq($min: null, $max: null) {\n    $min-type: type-of($min);\n    $max-type: type-of($max);\n\n    @if $min-type==string {\n        @if $min==xs {\n            $min: \"(min-width: #{map-get($breakpoints, xs)})\";\n        }\n        @else if $min==sm {\n            $min: \"(min-width: #{map-get($breakpoints, sm)})\";\n        }\n        @else if $min==md {\n            $min: \"(min-width: #{map-get($breakpoints, md)})\";\n        }\n        @else if $min==lg {\n            $min: \"(min-width: #{map-get($breakpoints, lg)})\";\n        }\n        @else if $min==ll {\n            $min: \"(min-width: #{map-get($breakpoints, ll)})\";\n        }\n        @else {\n            @warn \"mq mixin supports: sm, md, lg, ll\";\n        }\n    }\n    @else if $min-type==number {\n        $min: \"(min-width: #{$min})\";\n    }\n\n    @if $max-type==string {\n        @if $max==xs {\n            $max: \"(max-width: #{map-get($breakpoints, xs) - 1})\";\n        }\n        @else if $max==sm {\n            $max: \"(max-width: #{map-get($breakpoints, sm) - 1})\";\n        }\n        @else if $max==md {\n            $max: \"(max-width: #{map-get($breakpoints, md) - 1})\";\n        }\n        @else if $max==lg {\n            $max: \"(max-width: #{map-get($breakpoints, lg) - 1})\";\n        }\n        @else if $max==ll {\n            $max: \"(max-width: #{map-get($breakpoints, ll) - 1})\";\n        }\n        @else {\n            @warn \"mq mixin supports: xs, sm, md, lg, ll\";\n        }\n    }\n\n    @else if $max-type==number {\n        $max: \"(max-width: #{$max})\";\n    }\n\n    $query: false;\n    @if $min and $max {\n        $query: \"#{$min} and #{$max}\";\n    }\n    @else if $min {\n        $query: \"#{$min}\";\n    }\n    @else if $max {\n        $query: \"#{$max}\";\n    }\n\n    @if (not $query) {\n        @warn \"Invalid media query\";\n    }\n    @else {\n        @media #{$query} {\n            @content;\n        }\n    }\n}\n\n@mixin mob() {\n    @include mq(null, md) {\n        @content;\n    }\n}\n\n@mixin smart() {\n    @include mq(null, sm) {\n        @content;\n    }\n}\n\n@mixin tab-portrait() {\n    @include mq(sm, md) {\n        @content;\n    }\n}\n\n@mixin tab-landscape() {\n    @include mq(md, lg) {\n        @content;\n    }\n}\n\n@mixin desk() {\n    @include mq(lg) {\n        @content;\n    }\n}","$white: #f2f2f2;\n$pure-black: #030303;\n$light-black: #181818;\n$black: #141414;\n$red: #e50914;\n$grey: #101011;\n$blue-google: #1356c7;\n\n$main-font: 'Inter', sans-serif;\n$fakeflix-font: 'Bebas Neue', cursive;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
